export default __webpack_public_path__ + "static/media/lamb-squash-skillet.934f1b36.jpeg";